import {
  Button,
  Card,
  CardHeader,
  Dialog,
  FormControl,
  Grid,
  IconButton,
  Input,
  InputAdornment,
  MenuItem,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { PetCard } from "./PetCard";
import {
  GridContextProvider,
  GridDropZone,
  GridItem as PetItem,
  swap,
} from "react-grid-dnd";
import { useMaterialUIController } from "context";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { getMainPages } from "controllers/MenuController";
import { getCapsuleSubForms } from "controllers/MenuController";
import getText from "Translator";
import { getFormPages } from "controllers/MenuController";
import { getCapsuleQuestionsForCondition } from "controllers/QuestionController";
import { getTitleQuestionsForCondition } from "controllers/QuestionController";
import { getConditionNew } from "controllers/ConditionController";
import { storeConditionNew } from "controllers/ConditionController";
import { displaySuccessMessage } from "controllers/validation";
import { updateConditionsRowNumbers } from "controllers/ConditionController";
import { displayErrorMessage } from "controllers/validation";
import { updateConditionNew } from "controllers/ConditionController";
import NavigateNext from "@mui/icons-material/NavigateNext";
import PetCardMove from "./PetCardMove";
import SendToColleagueComponent from "./SendToColleagueComponent";
import { PetCardQuestion } from "./PetCardQuestion";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";

import AutorenewIcon from "@mui/icons-material/Autorenew";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import { PetCard2 } from "./PetCard2";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import LoadingOverlay from "react-loading-overlay";
import { removeConditionNew } from "controllers/ConditionController";
import { getConditionForVisible } from "controllers/QuestionController";
import { setConditionForVisible } from "controllers/QuestionController";

let questionListss = [];
const PETSD = [
  { id: "(", type: "op", text: "(", pindex: 0 },
  { id: ")", type: "op", text: ")", pindex: 0 },
  { id: "+", type: "op", text: "+" },
  { id: "-", type: "op", text: "-" },
  { id: "*", type: "op", text: "*" },
  { id: "/", type: "op", text: "/" },
  { id: "**", type: "op", text: "^" },
  { id: "<", type: "op", text: "<" },
  { id: "<=", type: "op", text: "<=" },
  { id: ">", type: "op", text: ">" },
  { id: ">=", type: "op", text: ">=" },
  { id: "==", type: "op", text: "=" },
  { id: "!=", type: "op", text: "!=" },
  { id: "%", type: "op", text: "%" },
  { id: "log", type: "op", text: "log" },
  { id: "ln", type: "op", text: "ln" },
  { id: "radical", type: "op", text: "Radical" },
  { id: "&&", type: "op", text: "AND" },
  { id: "||", type: "op", text: "OR" },
  // { id: "now", type: "DATE", text: "NOW", mode: "DATE" },
  // { id: "br", type: "other", text: "BR" },
  // { id: "patient", type: "other", text: "patient's name" },
  // { id: "birth", type: "other", text: "patient's birth" },
  // { id: "code", type: "other", text: "patient's code" },
  // { id: "user", type: "other", text: "user's name" },
  // { id: "senderuser", type: "other", text: "sender user's name" },
  { id: ":", type: "op", text: ":" },
];
let PETS = [];
const XOperators = ["now", "radical", "ln"];
let editId;
let pindex = 0;
let pindexc = 0;
let coleagueList = [];

const CondtionView = (props) => {
  const [questions, setQuestions] = useState([]);
  const [datas, setDatas] = useState([]);
  const [newValue, setNewValue] = useState("");
  const [indexp, setIndexp] = useState();
  const [petType, setPetType] = useState();

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [qloading, setQLoading] = useState(false);
  const [pageMode, setPageMode] = useState("");
  const [startPage, setStartPage] = useState("");
  const [startPageList, setStartPageList] = useState([]);
  const [subFormList, setSubFormList] = useState([]);
  const [subForm, setSubForm] = useState("");
  const [position, setPosition] = useState("top");
  const [basket, setBasket] = useState([]);
  const [selectedlistx, setSelectedlistx] = useState([]);
  function onChange(sourceId, sourceIndex, targetIndex, targetId) {
    const nextState = swap(basket, sourceIndex, targetIndex);
    setBasket(updatePIndex(nextState));
  }
  const { headline, capsule, title, form, page, type, formType, question } =
    useParams();
  const [controller] = useMaterialUIController();
  const navigate = useNavigate();
  useEffect(() => {
    PETS = PETSD;
    if (type == "subform" || type == "visible") {
      PETS = PETS.filter((a) => a.id != ":");
    }
    if (type == "visible") {
      PETS = PETS.filter(
        (a) =>
          a.id != ":" &&
          a.id != "senderuser" &&
          a.id != "user" &&
          a.id != "code" &&
          a.id != "patient" &&
          a.id != "br"
      );
    }

    setPageMode("new");
    setViewInit();
    getQuestions("");
    getNewConditions();
  }, []);
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = (val, ptype) => {
    setIndexp(val);
    setPetType(ptype);
    setOpen(true);
  };

  const setViewInit = async () => {
    try {
      if (!formType) {
        return;
      }

      if (formType == 1) {
        setLoading(true);
        let list = await getMainPages(
          controller.lang,
          { capsule },
          controller.token
        );
        console.log("listlistlistlist", list);
        setLoading(false);
        if (list.success) {
          setStartPageList(list.data);

          setLoading(true);
          let subFormlistx = await getCapsuleSubForms(
            controller.lang,
            { capsule },
            controller.token
          );
          console.log("subFormlistx", subFormlistx);
          setLoading(false);
          if (subFormlistx.success) {
            setStartPage(
              list.data.filter((a) => a.id + "" == page + "")[0].text
            );
            if (subFormlistx.data.length === 0) {
              Swal.fire({
                text: getText("subformmess", controller.lang),
                confirmButtonText: getText("ok", controller.lang),
                icon: "error",
              });
              navigate(-1, { replace: true });
              return;
            }
            setSubFormList(subFormlistx.data);
            setSubForm(subFormlistx.data[0].id + "");
            setPageMode("new");
          } else {
            displayErrorMessage(
              controller.lang,
              subFormlistx.message,
              subFormlistx.code
            );
          }
        } else {
          displayErrorMessage(controller.lang, list.message, list.code);
        }
      } else if (formType == 2) {
        console.log("formformform", form);
        let list = await getFormPages(
          controller.lang,
          { form },
          controller.token
        );
        console.log("formformform", list);
        setStartPageList(list.data);

        let subFormlistx = await getCapsuleSubForms(
          controller.lang,
          { capsule },
          controller.token
        );

        if (subFormlistx.data.length < 2) {
          Swal.fire({
            text: getText("subformmess", controller.lang),
            confirmButtonText: getText("ok", controller.lang),
            icon: "error",
          });
        }

        let sList = subFormlistx.data.filter((a) => a.id + "" !== form + "");
        setSubFormList(sList);
        setSubForm(
          subFormlistx.data.filter((a) => a.id + "" === form + "")[0].id + ""
        );
        setStartPage(list.data.filter((a) => a.id + "" == page + "")[0].text);
        setPageMode("new");
      }
    } catch (err) {
      console.log(err);
      displayErrorMessage(controller.lang);
    }
  };
  const getQuestions = async (search) => {
    setQLoading(true);
    let data;

    try {
      // if (type === "capsule") {
      //   data = await getTitleQuestionsForCondition(
      //     controller.lang,
      //     { title },
      //     controller.token
      //   );
      //   setQLoading(false);
      // } else {
      data = await getCapsuleQuestionsForCondition(
        controller.lang,
        { capsule, rowsPerPage: 100, page: 1 },
        controller.token
      );
      setQLoading(false);
      //  }
      if (data.success) {
        questionListss = data.data;
        setQuestions(data.data);
      } else {
        displayErrorMessage(controller.lang, data.message, data.code);
      }
    } catch (err) {
      console.log(err);
      displayErrorMessage(controller.lang);
    }
    setQLoading(false);
  };
  const getNewConditions = async () => {
    try {
      let conditions;
      setLoading(true);
      if (type == "visible") {
        let postData = {
          id: question,
        };

        conditions = await getConditionForVisible(
          controller.lang,
          postData,
          controller.token
        );
      } else {
        let postData = {
          id:
            type == "capsule" || type == "subform" || type == "coleague"
              ? capsule
              : question,
          type,
          startPage: page,
          capsule:
            type == "capsule" || type == "subform" || type == "coleague"
              ? capsule
              : question,
        };

        conditions = await getConditionNew(
          controller.lang,
          postData,
          controller.token
        );
      }
      console.log("conditionsconditionsconditions", conditions);
      setLoading(false);
      if (conditions.success) {
        setDatas(conditions.data);
        setLoading(false);
        return conditions.data;
      } else {
        displayErrorMessage(
          controller.lang,
          conditions.message,
          conditions.code
        );
      }
    } catch (err) {
      console.log(err);
      displayErrorMessage(controller.lang);
    }
    setLoading(false);
  };

  const removeItem = (index) => {
    const updatedPets = [...basket];
    updatedPets.splice(index, 1);
    console.log(updatedPets);
    setBasket(updatePIndex(updatedPets));
  };
  const setSendColeagueHandler = (data) => {
    coleagueList = data;
  };
  const setModeItem = (index, mode) => {
    const updatedPets = [...basket];
    updatedPets[index].mode = mode;
    setBasket(updatePIndex(updatedPets));
  };
  const addItem = (item) => {
    let updatedPets = [...basket];
    updatedPets.push(item);
    setBasket(updatePIndex(updatedPets));
  };
  const validateCondition = (updatedPets) => {
    console.log(updatedPets);
    if (
      updatedPets.length > 2 &&
      updatedPets[updatedPets.length - 3].mode &&
      updatedPets[updatedPets.length - 3].mode == "DATE" &&
      (updatedPets[updatedPets.length - 2].mode !== "-" ||
        updatedPets[updatedPets.length - 1].mode !== "DATE")
    ) {
      alert("date mode error");
      return;
    }

    updatedPets.map((item, index) => {
      if (index > 0) {
        if (
          item.type == "op" &&
          updatedPets[index - 1].type == "op" &&
          updatedPets[index - 1].id == item.id &&
          item.id !== "(" &&
          item.id !== ")"
        ) {
          alert("operator repeat error");
          return;
        }
        if (
          item.type == "op" &&
          updatedPets[index - 1].type == "op" &&
          XOperators.filter((a) => a == item.id).length == 0 &&
          item.id !== "(" &&
          item.id !== ")"
        ) {
          alert("operator repeat error");
          return;
        }
      }
    });
  };
  const updatePIndex = (updatedPets) => {
    pindex = 0;
    pindexc = 0;
    updatedPets.map((pit) => {
      if (pit.id == ")") {
        pit.pindex = 0;
      }
    });
    updatedPets.map((pit) => {
      if (pit.id == "(") {
        pindex += 1;
        pit.pindex = pindex;
      } else if (pit.id == ")") {
        pindexc = pindex;

        while (
          updatedPets.filter((pit) => pit.id == ")" && pit.pindex == pindexc)
            .length > 0
        ) {
          pindexc--;
        }

        pit.pindex = pindexc;

        if (pindexc < 0) {
          Swal.fire({
            text: getText("parantezalert", controller.lang),
            icon: "warning",
            confirmButtonText: getText("ok", controller.lang),
          });
        }
      }
    });
    return updatedPets;
  };
  const copyConditionNewHandler = async (item) => {
    try {
      let result = "";

      let conditionNew = {
        id: type == "capsule" || type == "subform" ? capsule : question,
        type,
        condition: JSON.stringify(item.condition),
        result,
        capsule,
        startPage: page,
        subForm,
        position: item.position,
        rownumber: item.rownumber + 1,
      };

      let res;
      setLoading(true);
      console.log("conditionNewconditionNew", conditionNew);
      res = await storeConditionNew(
        controller.lang,
        conditionNew,
        controller.token
      );
      if (res.success) {
        displaySuccessMessage(controller.lang, res.message, res.code);
        let sss = await getNewConditions();
        sss.map((item, index) => {
          item.rownumber = index + 1;
        });
        updateConditionsRowNumbers(controller.lang, sss, controller.token);
        getNewConditions();
      } else {
        displayErrorMessage(controller.lang, res.message, res.code);
      }
      if (res.errorCode === 101) {
        props.history.replace("/");
      }
      setLoading(false);
    } catch (err) {
      console.log(err);
    }
  };
  const submitConditionNewHandler = async () => {
    try {
      if (basket.length === 0) {
        Swal.fire({
          text: getText("validateformula", controller.lang),
          confirmButtonText: getText("ok", controller.lang),
          icon: "warning",
        });
        return;
      }
      let result = "";
      let temp = [];
      basket.map((item) => {
        if (item.code) {
          console.log("item.codeitem.code", item.code);
          temp.push({
            id: item.code,
            text: item.text,
            type: item.type,
            mode: item.mode,
          });
        } else {
          temp.push(item);
        }
      });
      let conditionNew = {
        id:
          type == "capsule" || type == "subform" || type == "coleague"
            ? capsule
            : question,
        type,
        condition: JSON.stringify(temp),
        result,
        capsule,
        startPage: page,
        subForm,
        position,
        coleagues:
          type == "coleague" ? JSON.stringify(coleagueList) : undefined,
        rownumber: datas.length + 1,
      };

      let res;
      setLoading(true);
      console.log("conditionNewconditionNew", conditionNew);
      if (type == "visible") {
        console.log("datasdatasdatas", datas);
        if (datas.length > 0) {
          setLoading(false);

          Swal.fire({
            text: getText("onlyonecondition", controller.lang),
            confirmButtonText: getText("ok", controller.lang),
            icon: "warning",
          });
          return;
        }
        res = await setConditionForVisible(
          controller.lang,
          { id: question, visibleCondition: JSON.stringify(temp) },
          controller.token
        );
      } else {
        res = await storeConditionNew(
          controller.lang,
          conditionNew,
          controller.token
        );
      }
      if (res.success) {
        displaySuccessMessage(controller.lang, res.message);
        setBasket([]);
        getNewConditions();
      } else {
        displayErrorMessage(controller.lang, res.message, res.code);
      }
      if (res.errorCode === 101) {
        props.history.replace("/");
      }
      setLoading(false);
    } catch (err) {
      console.log(err);
    }
  };
  const updateConditionNewHandler = async () => {
    if (basket.length === 0) {
      Swal.fire({
        text: getText("validateformula", controller.lang),
        confirmButtonText: getText("ok", controller.lang),
        icon: "warning",
      });
      return;
    }
    let temp = [];
    basket.map((item) => {
      if (item.code) {
        temp.push({
          id: item.code,
          text: item.text,
          type: item.type,
          mode: item.mode,
        });
      } else {
        temp.push(item);
      }
    });
    let conditionNew = {
      id: editId,
      position,
      coleagues: type == "coleague" ? JSON.stringify(coleagueList) : undefined,
      condition: JSON.stringify(temp),
    };

    let res;
    setLoading(true);
    if (type == "visible") {
      res = await setConditionForVisible(
        controller.lang,
        { id: question, visibleCondition: JSON.stringify(temp) },
        controller.token
      );
    } else {
      res = await updateConditionNew(
        controller.lang,
        conditionNew,
        controller.token
      );
    }

    if (res.success) {
      displaySuccessMessage(controller.lang, res.message);
      setBasket([]);
      getNewConditions();
      setPageMode("new");
    } else {
      displayErrorMessage(controller.lang, res.message, res.code);
    }
    if (res.errorCode === 101) {
      props.history.replace("/");
    }
    setLoading(false);
  };

  const handleDropRows = (droppedItem) => {
    if (!droppedItem.destination) return;
    var updatedList = [...datas];
    const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1);

    updatedList.splice(droppedItem.destination.index, 0, reorderedItem);

    updatedList.map((item, index) => {
      item.rownumber = index + 1;
    });
    updateConditionsRowNumbers(controller.lang, updatedList, controller.token);
    setDatas(updatedList);
  };
  return (
    <DashboardLayout>
      <DashboardNavbar title={getText("conditions", controller.lang)} />
      <LoadingOverlay
        active={loading}
        spinner
        text={getText("loading", controller.lang)}
      >
        <Grid
          container
          style={{
            marginBottom: 15,
          }}
        >
          <Grid item xs={6} sm={6} md={6}>
            <Card style={{ marginLeft: 15 }}>
              <h4
                style={{
                  margin: 0,
                  margin: 5,
                  borderBottom: "1px solid #f7f7f7",
                  color: "#039dfc",
                  flexDirection: "row",
                  fontSize: 16,
                }}
              >
                {getText("listofquestions", controller.lang)}{" "}
                <TextField
                  id="search"
                  fullWidth
                  variant="outlined"
                  placeholder="Search ..."
                  onChange={(event) => {
                    let temp = questionListss.filter(
                      (a) =>
                        (a.text + "")
                          .toLowerCase()
                          .includes(event.target.value.toLowerCase()) ||
                        (a.questionCode + "")
                          .toLowerCase()
                          .includes((event.target.value + "").toLowerCase())
                    );
                    setQuestions(temp);
                  }}
                />
              </h4>

              <div
                style={{
                  maxHeight:
                    type == "subform"
                      ? 600
                      : type == "question" || type == "visible"
                      ? 550
                      : 700,
                  minHeight:
                    type == "subform"
                      ? 600
                      : type == "question" || type == "visible"
                      ? 550
                      : 700,
                  overflowY: "scroll",
                }}
              >
                <LoadingOverlay
                  active={qloading}
                  spinner
                  text={getText("loading", controller.lang)}
                >
                  {questions.map((pet) => (
                    // <>
                    //   {pet.questionCode + " " + pet.text}
                    //   <br />{" "}
                    // </>

                    <PetCardQuestion
                      addItem={addItem}
                      draggable
                      id={pet.id}
                      type="que"
                      text={pet.text}
                      code={pet.questionCode}
                      answers={pet.answers}
                      mode={pet.questionType}
                    />
                  ))}
                </LoadingOverlay>
              </div>
            </Card>
          </Grid>
          <Grid item xs={6} sm={6} md={6}>
            <Card style={{ marginBottom: 15 }}>
              <h4
                style={{
                  margin: 0,
                  margin: 5,
                  borderBottom: "1px solid #f7f7f7",
                  color: "#039dfc",
                  fontSize: 16,
                }}
              >
                {getText("opertators", controller.lang)}
              </h4>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                }}
              >
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    padding: 10,
                  }}
                >
                  {PETS?.map((pet) => (
                    <PetCard
                      draggable
                      addItem={addItem}
                      id={pet.id}
                      text={pet.text}
                      code={pet.code}
                      pindex={pet.pindex}
                      type={pet.type}
                      mode={pet.mode}
                    />
                  ))}

                  <FormControl
                    variant="outlined"
                    fullWidth
                    style={{
                      marginTop: 10,
                    }}
                  >
                    <Input
                      placeholder=" add value"
                      id="input-with-icon-adornment"
                      onChange={(event) => {
                        setNewValue(event.target.value);
                      }}
                      value={newValue}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => {
                              addItem({
                                id: newValue,
                                text: newValue,
                                type: "user",
                              });
                              setNewValue("");
                            }}
                          >
                            <NavigateNext />
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                </Grid>
              </div>
            </Card>

            <Card style={{ padding: 15 }}>
              <GridContextProvider onChange={onChange}>
                <GridDropZone
                  id="items"
                  boxesPerRow={4}
                  rowHeight={40}
                  style={{
                    height: type == "coleague" ? 200 : 300,
                    direction: "ltr",
                  }}
                >
                  {basket.map((pet, index) => (
                    <PetItem key={index}>
                      <PetCardMove
                        // setModeItem={setModeItem}
                        // removeItem={removeItem}
                        handleOpen={handleOpen}
                        id={pet.id}
                        type={pet.type}
                        text={pet.text}
                        mode={pet.mode}
                        index={index}
                        pindex={pet.pindex}
                      />
                    </PetItem>
                  ))}
                </GridDropZone>
              </GridContextProvider>
              <Dialog
                open={open}
                onClose={handleClose}
                style={{ minHeight: 120 }}
              >
                {petType == "que" && (
                  <>
                    <MenuItem
                      style={{ backgroundColor: "#a6a6a6" }}
                      onClick={() => {
                        setModeItem(indexp, "value");
                        handleClose();
                      }}
                    >
                      مقدار گزینه
                    </MenuItem>
                    <MenuItem
                      style={{ backgroundColor: "#49f56c" }}
                      onClick={() => {
                        setModeItem(indexp, "title");
                        handleClose();
                      }}
                    >
                      عنوان سوال
                    </MenuItem>
                    <MenuItem
                      style={{ backgroundColor: "#30bff2" }}
                      onClick={() => {
                        setModeItem(indexp, "text");
                        handleClose();
                      }}
                    >
                      متن گزینه
                    </MenuItem>
                  </>
                )}
                <MenuItem
                  onClick={() => {
                    removeItem(indexp);
                    handleClose();
                  }}
                >
                  حذف
                </MenuItem>
              </Dialog>
            </Card>
            <Card style={{ padding: 15, marginTop: 15 }}>
              <div color="primary" size="small" style={{ padding: 6 }}>
                {type == "subform" && (
                  <div>
                    <h4
                      style={{
                        margin: 0,
                        padding: 5,
                        borderBottom: "1px solid #f7f7f7",
                        color: "#039dfc",
                        fontSize: 16,
                      }}
                    >
                      {getText("startform", controller.lang) + " " + startPage}
                      {getText("tosubform", controller.lang) + " :"}
                    </h4>

                    <TextField
                      style={{ backgroundColor: "#FFF" }}
                      id="subForm"
                      fullWidth={true}
                      value={subForm}
                      onChange={(event) => {
                        setSubForm(event.target.value + "");
                      }}
                      disabled={pageMode === "edit"}
                      select
                      variant="outlined"
                      required={true}
                    >
                      {subFormList.map((sf) => (
                        <MenuItem key={sf.id} value={sf.id}>
                          {sf.text}
                        </MenuItem>
                      ))}
                    </TextField>
                  </div>
                )}
                {type == "capsule" && (
                  <div>
                    <h4
                      style={{
                        margin: 0,
                        padding: 5,
                        borderBottom: "1px solid #f7f7f7",
                        color: "#039dfc",
                        fontSize: 16,
                      }}
                    >
                      {getText("restextpossition", controller.lang)}
                    </h4>

                    <TextField
                      style={{ backgroundColor: "#FFF" }}
                      id="position"
                      fullWidth={true}
                      value={position}
                      onChange={(event) => {
                        setPosition(event.target.value + "");
                      }}
                      select
                      variant="outlined"
                      required={true}
                    >
                      <MenuItem key={"top"} value={"top"}>
                        top
                      </MenuItem>
                      <MenuItem key={"bot"} value={"bot"}>
                        bottom
                      </MenuItem>
                    </TextField>
                  </div>
                )}

                {type == "coleague" && (
                  <div>
                    {/* <h4
                      style={{
                        margin: 0,
                        padding: 5,
                        borderBottom: "1px solid #f7f7f7",
                        color: "#039dfc",
                        fontSize: 16,
                      }}
                    >
                      {getText("restextpossition", controller.lang)}
                    </h4> */}

                    <SendToColleagueComponent
                      setSendColeagueHandler={setSendColeagueHandler}
                      selectedlistx={selectedlistx}
                    />
                  </div>
                )}

                <Button
                  variant="contained"
                  style={{ marginTop: 5, float: "right" }}
                  onClick={() => {
                    if (pageMode == "new") {
                      submitConditionNewHandler();
                    } else {
                      updateConditionNewHandler();
                    }
                  }}
                >
                  <div style={{ color: "#FFF" }}>
                    {getText(
                      pageMode == "new" ? "submit" : "edit",
                      controller.lang
                    )}
                  </div>
                </Button>
                {pageMode == "edit" && (
                  <Button
                    style={{ marginTop: 5, float: "right" }}
                    onClick={() => {
                      setPageMode("new");
                      setBasket([]);
                    }}
                  >
                    {getText("cancel", controller.lang)}
                  </Button>
                )}
              </div>
            </Card>
          </Grid>
        </Grid>

        <Grid container>
          <Grid xs={12} sm={12} md={12}>
            <Card>
              <h4
                style={{
                  margin: 0,
                  margin: 5,
                  borderBottom: "1px solid #f7f7f7",
                  color: "#039dfc",
                  flexDirection: "row",
                  fontSize: 16,
                }}
              >
                {getText("conditions", controller.lang)}{" "}
              </h4>
              <div
                style={{
                  paddingLeft: 0,
                  paddingRight: 0,
                  paddingBottom: 0,
                  maxHeight: 400,
                  minHeight: 100,
                  overflow: "scroll",
                }}
              >
                <DragDropContext onDragEnd={handleDropRows}>
                  <Droppable droppableId="list-container">
                    {(provided) => (
                      <div
                        className="list-container"
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                      >
                        {datas.map((cond, index) => (
                          <Draggable
                            key={"condition" + cond.id}
                            draggableId={cond.id}
                            index={index}
                          >
                            {(provided) => (
                              <div
                                className="item-container"
                                style={{
                                  borderBottom: "1px solid #000",
                                }}
                                ref={provided.innerRef}
                                {...provided.dragHandleProps}
                                {...provided.draggableProps}
                              >
                                <Grid
                                  container
                                  style={{
                                    backgroundColor:
                                      index % 2 == 0 ? "#FFF" : "#f7f7f7",
                                  }}
                                >
                                  <Grid
                                    xs={3}
                                    sm={3}
                                    md={2}
                                    style={{
                                      padding: 0,
                                      display: "flex",
                                      flexDirection: "row",
                                    }}
                                  >
                                    <IconButton
                                      style={{ padding: 0 }}
                                      onClick={async () => {
                                        let newData = {
                                          id: cond.id,
                                          type,
                                          capsule,
                                          startPage: page,
                                        };
                                        Swal.fire({
                                          text: getText(
                                            "deleteconfirm",
                                            controller.lang
                                          ),
                                          icon: "warning",
                                          showCancelButton: true,
                                          confirmButtonColor: "#3085d6",
                                          cancelButtonColor: "#d33",
                                          confirmButtonText: getText(
                                            "confirmButtonText",
                                            controller.lang
                                          ),
                                          cancelButtonText: getText(
                                            "cancel",
                                            controller.lang
                                          ),
                                        }).then(async (result) => {
                                          if (result.value) {
                                            setLoading(true);
                                            let data;

                                            if (type == "visible") {
                                              data =
                                                await setConditionForVisible(
                                                  controller.lang,
                                                  {
                                                    id: question,
                                                    visibleCondition: "",
                                                  },
                                                  controller.token
                                                );
                                            } else {
                                              data = await removeConditionNew(
                                                controller.lang,
                                                newData,
                                                controller.token
                                              );
                                            }

                                            if (data.success) {
                                              displaySuccessMessage(
                                                controller.lang,
                                                data.message
                                              );
                                              getNewConditions();
                                            } else {
                                              displayErrorMessage(
                                                controller.lang,
                                                data.message,
                                                data.code
                                              );
                                            }
                                            if (data.errorCode === 101) {
                                              props.history.replace("/");
                                            }

                                            setLoading(false);
                                          }
                                        });
                                      }}
                                    >
                                      <HighlightOffIcon color="primary" />
                                    </IconButton>
                                    <IconButton
                                      style={{ padding: 0 }}
                                      onClick={() => {
                                        let items = [];
                                        cond.condition.map((item) => {
                                          if (item.id) items.push(item);
                                        });
                                        setBasket(updatePIndex(items));
                                        if (type == "subform") {
                                          setSubForm(cond.subForm + "");
                                        }

                                        if (type == "coleague") {
                                          setSelectedlistx(
                                            JSON.parse(cond.coleagues)
                                          );
                                        }
                                        setPosition(cond.position);
                                        editId = cond.id;
                                        setPageMode("edit");
                                      }}
                                    >
                                      <AutorenewIcon color="primary" />
                                    </IconButton>
                                    {type !== "visible" && (
                                      <IconButton
                                        style={{ padding: 0 }}
                                        onClick={() => {
                                          copyConditionNewHandler(cond);
                                        }}
                                      >
                                        <FileCopyIcon color="primary" />
                                      </IconButton>
                                    )}
                                    {type !== "visible" && (
                                      <div
                                        style={{
                                          alignItems: "center",
                                          justifyItems: "center",
                                          width: 20,
                                          minWidth: 20,
                                          textAlign: "center",
                                          justifyContent: "center",
                                          height: 20,
                                          backgroundColor: "#039dfc",
                                          borderRadius: 10,
                                          fontSize: 12,
                                          color: "#FFF",
                                          marginTop: 7,
                                        }}
                                      >
                                        {cond.rownumber}
                                      </div>
                                    )}
                                  </Grid>
                                  <Grid
                                    xs={9}
                                    sm={9}
                                    md={10}
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                      flexWrap: "wrap",
                                      width: "100%",
                                    }}
                                  >
                                    {cond.condition?.map((pet) => (
                                      <PetCard2
                                        id={pet.id}
                                        type={pet.type}
                                        text={pet.text}
                                        code={pet.questionCode}
                                        mode={pet.mode}
                                        pindex={pet.pindex}
                                      />
                                    ))}
                                  </Grid>
                                </Grid>
                              </div>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </div>
            </Card>
          </Grid>
        </Grid>
      </LoadingOverlay>
    </DashboardLayout>
  );
};

export default CondtionView;
